import scraperApi from "api";
import { ActiveCouponsDataRouteType } from "routes/data-routes/billing-data/coupons/active-coupons/route.meta";


// The backend routes this provider-neutral request to Chargebee or Stripe. Stripe
// responses are read directly from the licensed base subscription item.
export const loader: ActiveCouponsDataRouteType["route"]["loader"] = async ({ request }) => {
  return {
    activeCoupons: await scraperApi.billing.coupons.getActiveCoupons({ signal: request.signal })
  };
}
